import { Component } from 'preact';
import PropTypes from 'prop-types';

// Components
import { checkConditions, getPackageDisplay } from '../../../../utilities/package/packageUtils';
import {
  getCoverageCodesAndMergeCodes,
  replaceData,
} from '../../../../utilities/common';
import { stepShowHide } from '../../../../utilities/form/formUtils';

import SelectorItem from './SelectorItem';
import Label from '../../../Form/Label';

class Packages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selecetedPackage: '',
    };
    this.renderSelectorItems = this.renderSelectorItems.bind(this);
    this.selectorClick = this.selectorClick.bind(this);
  }

  componentDidMount() {
    const { productBoxes, userData } = this.props;
    productBoxes.forEach((item) => {
      const isRecommended =
        item.recommended && checkConditions(item.recommended, userData);
      if (isRecommended) {
        this.setState({ selecetedPackage: item.title });
      }
    });
  }
  selectorClick(value) {
    this.setState({ selecetedPackage: value });
  }

  renderSelectorItems(sort) {
    const {
      userData,
      values,
      initialValues,
      actions,
      dispatch,
      label,
      coverageText,
      recommendedText,
      selectedPackageText,
      advancedCoverage,
      setValues,
      toolTip,
      buttonTextMobile,
      productFooterNote,
      productFooterNoteList,
      customProduct,
      customProductFooterNote,
      customProductPriceMessage,
      labelActions,
      feesAndCharges,
      customTotalPriceText,
    } = this.props;

    let { productBoxes } = this.props;
    const { selecetedPackage } = this.state;
    const { packages, coverageMerge } = initialValues;

    if (sort) {
      productBoxes = [...productBoxes].sort((p1, p2) => {
        let isRecommended =
          p1.recommended && checkConditions(p1.recommended, userData);
        if (isRecommended) {
          return -1;
        }

        isRecommended =
          p2.recommended && checkConditions(p2.recommended, userData);
        if (isRecommended) {
          return 1;
        }

        return 0;
      });
    }

    return productBoxes.map((productSelector) => {
      const { recommended, packageId, coverages } = productSelector;
      const packageItem = packages.reduce((ag, element) => {
        return element.id === packageId ? element : ag;
      }, {});
      const packageDisplay = getPackageDisplay(packageItem, userData);
      if (packageDisplay) {
        const [coverageCodes, coverageCodesMerge] = getCoverageCodesAndMergeCodes(
          coverages &&
          coverages.split('.').reduce((obj, index) => obj[index], userData),
          coverageMerge,
          userData,
          packageItem
        );

        const campaign =
          initialValues.campaign &&
          (!initialValues.campaign.showForPackages ||
            initialValues.campaign.showForPackages.includes(packageId))
            ? initialValues.campaign.productSelector || {}
            : {};

        const column = 12 / productBoxes.length;
        const isRecommended =
          recommended && checkConditions(recommended, userData);
        const priceUnitLabel = replaceData(label, userData);
        let unit =
          Object.hasOwnProperty.call(initialValues, 'units') &&
          Object.hasOwnProperty.call(userData, priceUnitLabel)
            ? initialValues.units[userData[priceUnitLabel]]
            : priceUnitLabel;
        const showPrePrice =
          campaign.showPrePrice || productSelector.showPrePrice;

        if (advancedCoverage) {
          // Set form params for each coverage code.
          if (!values.coverageCodes) {
            values.coverageCodes = [
              ...coverages
                .split('.')
                .reduce((obj, index) => obj[index], userData),
            ];
            values.coverageCodes.forEach((coverageCode) => {
              values[coverageCode] = true;
            });
            setValues({...values});
          }
        }

        if (
          productSelector.showHide &&
          stepShowHide(false, productSelector.showHide, userData, values)
        ) {
          return <div/>;
        }

        let {packagePrice} = productSelector;
        let customProductProps = {};
        if (customProductPriceMessage) {
          if (productSelector.title === customProduct) {
            packagePrice = customProductPriceMessage;
            customProductProps = {
              [`is${customProduct}`]: true,
            };
            unit = null;
          } else {
            customProductProps = {
              [`is${customProduct}`]: false,
            };
          }
        }

        const productSelectorItemDetails = {
          recommendedText,
          selectedPackageText,
          isRecommended,
          coverageText,
          packageItem,
          coverageCodes,
          coverageCodesMerge,
          advancedCoverage,
          actions,
          labelActions,
          dispatch,
          label,
          column,
          toolTip,
          productSelector: {
            ...productSelector,
            packagePrice,
            customProduct,
            customProductProps,
            showPrePrice,
          },
          initialValues,
          userData,
          campaign,
          values,
          unit,
          buttonTextMobile,
          productFooterNote,
          customProductFooterNote,
          productFooterNoteList,
          feesAndCharges,
          customTotalPriceText,
        };
        return (<SelectorItem
          {...productSelectorItemDetails}
          selectedItem={selecetedPackage}
        />);
      }
    });
  }

  render() {
    const {
      productFooterNote,
      productFooterNoteList,
      labelActions,
      dispatch,
      values,
      setValues,
      productBoxes,
      customProductFooterNote,
      userData,
    } = this.props;

    const { selecetedPackage } = this.state;
    const list = productBoxes.map((item) => {
      const packageNameDisplay = getPackageDisplay(item, userData);
      /* eslint-disable-next-line */
      if(packageNameDisplay){
        return (<li key={item.title} className={item.title === selecetedPackage ? 'active' : ''} onClick={() => this.selectorClick(item.title)}>{item.title}</li>)
      }
    });

    return (
      <div>
        {selecetedPackage !== '' &&
          <ul
            key={selecetedPackage}
            className="product-selector-tab-v3"
          >
            {list}
          </ul>
        }
        <div className='grid align-center align-items-flex-end'>
          {this.renderSelectorItems()}
        </div>
        {!customProductFooterNote && (
          <div className='productbox__footernote  grid__col grid__col--12 grid__col--md-12'>
            <Label
              id='advancedProductFooterNote'
              label={productFooterNote}
              className='label__action'
              actions={labelActions}
              dispatch={dispatch}
              values={values}
              setValues={setValues}
            />
            {productFooterNoteList?.length > 0 && productFooterNoteList.map((productFooterNote, index) => (
              <Label
                key={"advancedProductFooterNoteIndex" + index}
                id={'advancedProductFooterNote' + index}
                label={productFooterNote.productFooterNoteLabel}
                className='label__action'
                actions={productFooterNote.productFooterNoteLabelActions}
                dispatch={dispatch}
                values={values}
                setValues={setValues}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default Packages;

Packages.defaultProps = {
  actions: [],
  advancedCoverage: false,
  defaultSelected: '',
  customProduct: 'Basis',
  customProductFooterNote: '',
  customProductPriceMessage: '',
  feesAndCharges: '',
  customTotalPriceText: '',
};

Packages.propTypes = {
  productFooterNote: PropTypes.string.isRequired,
  buttonTextMobile: PropTypes.string.isRequired,
  recommendedText: PropTypes.string.isRequired,
  selectedPackageText: PropTypes.string,
  initialValues: PropTypes.object.isRequired,
  coverageText: PropTypes.string.isRequired,
  productBoxes: PropTypes.array.isRequired,
  labelActions: PropTypes.array.isRequired,
  userData: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  toolTip: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  advancedCoverage: PropTypes.bool,
  actions: PropTypes.array,
  defaultSelected: PropTypes.string,
  customProduct: PropTypes.string,
  customProductFooterNote: PropTypes.string,
  customProductPriceMessage: PropTypes.string,
  feesAndCharges: PropTypes.string,
  customTotalPriceText: PropTypes.string,
  productFooterNoteList: PropTypes.array
};
